import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContexte";

const Callback = () => {
    const navigate = useNavigate();
    const { login, getAndClearRedirectTarget } = useAuth(); // Récupérer la fonction de redirection    // Configuration dynamique de l'URL de l'API
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4001';
    
    useEffect(() => {
    
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");
        const error = urlParams.get("error");
        const code = urlParams.get("code");
        
        // Si on a un token (nouvelle méthode via redirection backend)
        if (token) {
            // Supprimer le token de l'URL pour la sécurité
            window.history.replaceState({}, document.title, "/callback");
            
            try {
                login(token);
                
                // Vérifier s'il y a un serverId de destination
                const redirectServerId = getAndClearRedirectTarget();
                if (redirectServerId) {
                    navigate(`/server/${redirectServerId}`);
                } else {
                    navigate("/welcome");
                }
            } catch (error) {
                console.error("❌ Erreur lors du login:", error);
                navigate("/?error=login_failed");
            }
            return;
        }

        // Si on a une erreur
        if (error) {
            console.error("❌ Erreur d'authentification:", error);
            navigate("/?error=" + error);
            return;
        }

        // Fallback: ancienne méthode avec code (pour compatibilité)
        if (code) {
            // Supprimer le code de l'URL pour éviter réutilisation en cas de refresh
            window.history.replaceState({}, document.title, "/callback");
        
            fetch(`${API_URL}/auth/callback?code=${code}`)
                .then(res => res.json())
                .then(data => {
                    if (data.token) {
                        login(data.token);
                        
                        const redirectServerId = getAndClearRedirectTarget();
                        if (redirectServerId) {
                            navigate(`/server/${redirectServerId}`);
                        } else {
                            navigate("/welcome");
                        }
                    } else {
                        console.error("❌ Pas de token dans la réponse :", data);
                        navigate("/");
                    }
                })
                .catch(err => {
                    console.error("❌ Erreur lors de l'échange du code :", err);
                    navigate("/");
                });
                return;
        }
        navigate("/");
    
    }, [navigate, login, getAndClearRedirectTarget, API_URL]);
    

    return <div>Connexion en cours...</div>;
};

export default Callback;
